import React, { useState, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { AppStateType } from '../../reducers'
import { StyledIconButton } from './styled'
import { Menu, MenuItem, Tooltip } from '@material-ui/core'
import { AccountCircle } from '@material-ui/icons'
import { triggerNotification } from '../../actions/notifications'
import { copyToClipboard } from '../../services/common'
import { checkIfIsLightGroup } from '../../services/groups'
import { ICapabilitiesSummaryState } from '../../types/capabilitiesSummary'

export const UserProfileButton = () => {
    const dispatch = useDispatch()
    const capabilitiesSummary = useSelector<AppStateType, ICapabilitiesSummaryState>(
        (state) => state.capabilitiesSummary)
    const token = useSelector<AppStateType, string|undefined>((state) => state.auth.token)
    const [anchorEl, setAnchorEl] = useState(null)
    const isMemberOfAdvGroup = useMemo(() => {
        const keys = Object.keys(capabilitiesSummary.groups)
        return keys.some((k) => !checkIfIsLightGroup(capabilitiesSummary.groups[k].editionTypes))
    }, [capabilitiesSummary])
    const handleClick = (e): void => {
        setAnchorEl(e.currentTarget)
    }
    const handleClose = (): void => {
        setAnchorEl(null)
    }
    const copy = (): void => {
        copyToClipboard(token, () => {
            dispatch(triggerNotification('Token copied to clipboard'))
        })
    }
    return (
        isMemberOfAdvGroup ? <>
            <Tooltip title="User profile options">
                <StyledIconButton id="user-profile" onClick={handleClick}>
                    <AccountCircle/>
                </StyledIconButton>
            </Tooltip>
            <Menu
                id="user-profile-menu"
                anchorEl={anchorEl}
                keepMounted
                anchorOrigin={{
                    horizontal: 'left',
                    vertical: 'bottom',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                onClick={handleClose}>
                <MenuItem onClick={copy}>
                    Copy Token
                </MenuItem>
            </Menu>
        </> : <></>
    )
}
